import type { Row } from '@innovamat/glimmer-components';
import { useState } from 'react';

export function useStudentDrawer({
  reportsRows,
  classroomName,
}: {
  reportsRows: Row[];
  classroomName: string;
}) {
  const [studentData, setStudentData] = useState<
    (Row & { classroomName: string }) | undefined
  >(undefined);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const updateStudentData = (index: number): void => {
    const row = reportsRows[index];
    if (row) {
      setCurrentIndex(index);
      setStudentData({ ...row, classroomName });
    }
  };

  const handleOpenStudentDrawer = (row: Row): void => {
    updateStudentData(
      reportsRows.findIndex(
        (reportRow) => JSON.stringify(reportRow) === JSON.stringify(row)
      )
    );
  };
  const handleCloseStudentDrawer = (): void => setStudentData(undefined);
  const handleOnClickNext = (): void => updateStudentData(currentIndex + 1);
  const handleOnClickPrevious = (): void => updateStudentData(currentIndex - 1);
  return {
    showStudentDrawer: !!studentData,
    studentData,
    handleOpenStudentDrawer,
    handleCloseStudentDrawer,
    handleOnClickNext,
    handleOnClickPrevious,
    isNextDisabled: currentIndex >= reportsRows?.length - 1,
    isPreviousDisabled: currentIndex <= 0,
  };
}
